import ApplicationReviewTab from "./ApplicationReviewTab";
import React from "react";

const CompanySubRow = ({ visibleColumns, row }) => {
  const handleBackBtn = () => null;
  const handleClose = () => row.toggleRowExpanded();

  return (
    <tr className="bg-[#EDF0F5]">
      <td colSpan={visibleColumns.length} className="p-8 max-w-lg">
        <ApplicationReviewTab
          handleBackBtn={handleBackBtn}
          handleClose={handleClose}
        />
      </td>
    </tr>
  );
};

export default CompanySubRow;
